/**
 * Compute the zero based page based on the number of items and the number of items per page
 * @param itemCount
 * @param itemsPerPage
 * @constructor
 */
export function ComputePageNumber(itemCount: number, itemsPerPage: number): number {
	return Math.max(Math.ceil((itemCount + 1) / itemsPerPage) - 1, 0);
}
